var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"drawer"},[_c('path',{class:{ selected: _vm.selected, editable: _vm.editable },style:(_vm.additionalStyle),attrs:{"d":_vm.polygon.svg,"vector-effect":"non-scaling-stroke"}})])}
var staticRenderFns = []

export { render, staticRenderFns }